/**
 * en-GB messages added by shared reception task K-SR1 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const kSr1EnGB = {};
//# sourceMappingURL=k-sr1.js.map